module.exports = __webpack_public_path__ + "media/images/product-img-05-123f884f6f767d602f81fddbf689c279.jpg";